export * from "./allBlocks.pure";

import { RegisterAllNodeMaterialBlocks } from "./allBlocks.pure";
RegisterAllNodeMaterialBlocks();
